export const creditsLeftFormatted = (numberCredits) => {
  return numberCredits === -1 ? '∞' : numberCredits
}

export function generateIconURL (userUid) {
  return `https://api.dicebear.com/7.x/bottts/svg?seed=${userUid}`
}
